import React, { useEffect, useRef, useState } from 'react'
import { withAuth } from '../AuthContext'
import { withRouter } from 'react-router-dom'
import { getCurrencySign, shouldTranslateTo } from '../../utils/utils'
import {
  ActionButtons,
  LoadingButton,
  Subtitle,
  Title,
} from '../Utils/CustomClasses'
import styled from 'styled-components'
import Cookies from 'universal-cookie'
import MyFreebirdDashboard from './MyFreebirdDashboard'
import MyFreebirdPopup from './MyFreebirdPopup'
import MyFreebirdOpacityScreen from './MyFreebirdOpacityScreen'
import MyFreebirdProfilePanel from './MyFreebirdProfilePanel'
import MyFreebirdNavBar from './MyFreebirdNavBar'
import MyFreebirdDiscountPopup from './MyFreebirdDiscountPopup'
import MyFreebirdOpacityDiscountScreen from './MyFreebirdOpacityDiscountScreen'
import PhotoOnboarding from './PhotoOnboarding'
import EditProfileOnboarding from './EditProfileOnboarding'
import EditEmailOnboarding from './EditEmailOnboarding'
import ManageAccount from './ManageAccount'
import ChooseSubscriptionOnboarding from './ChooseSubscriptionOnboarding'
import ChoosePaymentOptionOnboarding from './ChoosePaymentOptionOnboarding'
import FeeSubscriptionOnboarding from './FeeSubscriptionOnboarding'
import ProofIdentityOnboarding from './ProofIdentityOnboarding'
import EditPhoneNumberOnboarding from './EditPhoneNumberOnboarding'
import { scrollIntoView } from '../Hooks/ScrollView'

const queryParams = new URLSearchParams(window.location.search)
const cookies = new Cookies()

const MyFreebirdSection = styled.section`
  background-color: #fff;
`

const TopSectionContainer = styled.div``

const TopSectionAction = styled.div`
  background-color: #154549;
  border: 1px solid #fff;
  border-radius: 8px;
  margin: 10px 20vw;
  padding: 30px;
  text-align: center;

  img {
    width: 130px;
  }

  @media screen and (max-width: 799px) {
    margin: 10px 5vw;
  }
`

const SubtitleOnboard = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
`

const ProceedButton = styled(ActionButtons)`
  background-color: #0bac5d;
  width: -webkit-fill-available;
`

const ProceedButtonLoading = styled(LoadingButton)`
  background-color: #0bac5d;
  width: -webkit-fill-available;
`

const MainSectionContainer = styled.div`
  position: relative;
`

const FlexRowProgress = styled.div`
  background-color: #154549;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  justify-content: space-between;

  @media screen and (max-width: 799px) {
    flex-direction: column;
  }

  @media screen and (min-width: 800px) {
    min-height: ${(props) => (props.minheight ? props.minheight : 'auto')};
  }
`

const TpL = styled.div`
  flex-basis: 50%;
  text-align: left;
  padding: 12px 10px 12px 20px;

  @media screen and (max-width: 799px) {
    text-align: center;
    padding: 12px 10px 0px 20px;
  }
`

const TpR = styled.div`
  flex-basis: 50%;
  text-align: right;
  padding: 12px 20px 12px 10px;

  @media screen and (max-width: 799px) {
    text-align: center;
    padding: 12px 10px 20px 10px;
  }
`

const FlexRowAction = styled(FlexRowProgress)`
  /*background-color: #491545;*/
  background-color: #463210;

  padding: 30px 5vw;
`

const TpLA = styled(TpL)`
  flex-basis: 70%;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 30px;
  padding: 0 60px 0 0;

  img {
    width: 100px;
  }

  @media screen and (max-width: 799px) {
    flex-direction: column;
    padding: 0 0 20px 0;
  }
`

const TpRA = styled(TpR)`
  flex-basis: 30%;
`

const ActionButtonMyFreebird = styled(ActionButtons)`
  background-color: #e75d66;
  display: unset;
  font-size: 16px;
  padding: 8px 36px;
`

const ActionButtonMyFreebirdGreen = styled(ActionButtonMyFreebird)`
  background-color: #0bac5d;
`

const ProfileUpdateSection = styled.div`
  background-image: url('images/onboarding/desktop-portraits.jpg');
  padding-bottom: 140px;
`

const FlexRowOnboarding = styled.div`
  display: flex;
  flex-direction: row;
  padding: 30px 30px;
`

const BackButton = styled(ActionButtons)`
  background-color: transparent;
  border: 1px solid #fff;
  padding: 6px 30px;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 200;

  @media screen and (max-width: 799px) {
    margin: 0;
    width: -webkit-fill-available;
  }
`

const MyFreebirdFreemium = (props) => {
  const [pageText, setPageText] = useState([])
  const [user, setUser] = useState([])
  const [country, setCountry] = useState('')
  const [currencySign, setCurrencySign] = useState('')
  const [subscriptionType, setSubscriptionType] = useState(null)
  const [accountStatus, setAccountStatus] = useState(null)
  const [chosenStep, setChosenStep] = useState('')
  const [promoPanelStep, setPromoPanelStep] = useState('')
  const [onboardingOpen, setOnboardingOpen] = useState(false)
  const [isIntersecting, setIsIntersecting] = useState(false)
  const [profileEnhanced, setProfileEnhanced] = useState(false)
  const [isPopupVisible, setIsPopupVisible] = useState(false)
  const [clickedFeeLink, setClickedFeeLink] = useState(false)
  const [discountCode, setDiscountCode] = useState('FREEB10125')
  const [forbiddenLinkClicked, setForbiddenLinkClicked] = useState([false, ''])
  const [newMemberMessage, setNewMemberMessage] = useState('')
  const [profileUpdate, setProfileUpdate] = useState(false)
  const actionRef = useRef(null)
  const [iAminSubscriptionFormPanel, setIAminSubscriptionFormPanel] =
    useState(false)

  const [countriesNice, setCountriesNice] = useState([])
  const [profilePicState, setProfilePicState] = useState('pending')
  const [emailState, setEmailState] = useState('pending')
  const [profileInfoState, setProfileInfoState] = useState('pending')
  const [contributionState, setContributionState] = useState('pending')
  const [idState, setIdState] = useState('pending')
  const [phoneState, setPhoneState] = useState('pending')
  const [showStepFromQueryString, setShowStepFromQueryString] = useState('')
  const [progressDelay, setProgressDelay] = useState(0)
  const [stage1Achieved, setStage1Achieved] = useState(false)
  const [isCopied, setIsCopied] = useState(false)
  const [isCopiedInSubFormPanel, setIsCopiedInSubFormPanel] = useState(false)

  useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(
        props.auth.user.currencyValue
      )
      setCurrencySign(currencySignData.sign)
    }

    if (queryParams.get('pfs')) {
      setShowStepFromQueryString(queryParams.get('pfs'))
      handleQueryStringStep(queryParams.get('pfs'))
    }

    if (queryParams.get('s')) {
      queryParams.get('s') === 'mp4' && handleUpgradeFromFreemium()
      setProfileUpdate(queryParams.get('s'))
    }

    if (queryParams.get('nf')) {
      queryParams.get('nf') === 'y' && setNewMemberMessage('nf')
    }

    if (queryParams.get('mu')) {
      queryParams.get('mu') === 'y' && setNewMemberMessage('mu')
    }

    getPageText('profile-app', language)
    getCurrency()
  }, [])

  useEffect(() => {
    var favsCountTally = 0
    var philosophyAdded = props.auth.user.philosophy ? true : false
    var favoPlaceAdded = props.auth.user.favoPlace ? true : false
    var favoVisitedPlaceAdded = props.auth.user.favoVisitedPlace ? true : false

    props.auth.user.favoBook && favsCountTally++
    props.auth.user.favoFilm && favsCountTally++
    props.auth.user.favoActor && favsCountTally++
    props.auth.user.favoMusician && favsCountTally++
    props.auth.user.favoFood && favsCountTally++
    props.auth.user.favoExercise && favsCountTally++
    props.auth.user.favoHero && favsCountTally++

    if (
      philosophyAdded &&
      favoPlaceAdded &&
      favoVisitedPlaceAdded &&
      favsCountTally >= 3
    ) {
      setProfileEnhanced(true)
    } else {
      setProfileEnhanced(false)
    }

    if (props.auth.user.countryId && country.length <= 1) {
      axios
        .get('/api/countries-list')
        .then((response) => {
          const countriesNiceList = response.data.map((item) => {
            return { value: item.id, label: item.nicename }
          })
          const country = countriesNiceList.find(
            (c) => c.value === props.auth.user.countryId
          )
          setCountriesNice(countriesNiceList)
          setCountry(country.label)
        })
        .catch(function (error) {
          console.log('Request failure: ', error)
        })
    }

    console.log('props.auth.user: ' + JSON.stringify(props.auth.user))
    console.log(
      'props.auth.user.accountStatus: ' + JSON.stringify(props.auth.user.status)
    )
    console.log(
      'props.auth.user.circleIntroStatus: ' +
        JSON.stringify(props.auth.user.circleIntroStatus)
    )
    console.log(
      'props.auth.user.subscriptionType: ' +
        JSON.stringify(props.auth.user.subscriptionType)
    )

    setUser(props.auth.user)
    setAccountStatus(props.auth.user.status)
    setSubscriptionType(props.auth.user.subscriptionType)

    setInterval(() => {
      if (props.auth.user.emailStatus === 'pending') {
        axios
          .get('/api/user/email-status')
          .then((response) => {
            if (response.data.emailStatus === 'verified') {
              const userData = {
                emailStatus: response.data.emailStatus,
              }
              props.auth.updateUser(userData)
              setUser(props.auth.user)
              window.open('/myfreebird', '_self')
            }
          })
          .catch(function (error) {
            console.log('Email status failure: ', error)
          })
      }
    }, 8000)
  }, [props.auth.user])

  useEffect(() => {
    calculateAccountProgressAndHiglighting()
  }, [pageText])

  /**
   *
   *  for back button
   *  check the storage if its true show popup
   *  the remove from storage
   */
  useEffect(() => {
    if (
      localStorage.getItem('clickedFeeLink') === 'true' &&
      props.auth.user.membershipFeeStatus !== 'completed'
    ) {
      console.log('>>>> pop up triggered from back button...')

      //
      // console.log('Popup should be visible now');
      setClickedFeeLink(true)
      setIsPopupVisible(true)
      localStorage.removeItem('clickedFeeLink')
    } else {
      // console.log('Popup should not be visible');
    }
  }, [])

  const calculateAccountProgressAndHiglighting = () => {
    var taskTally = 0

    if (props.auth.user.profilePhotoStatus === 'completed') {
      setProfilePicState('completed')
      taskTally += 1
    } else {
      setProfilePicState('current')
    }
  }

  const panelHasUpdated = (value) => {
    window.open('/myfreebird', '_self')
  }

  const handleProceed = (nextStep) => {
    console.log('handleProceed...')
    console.log('nextStep: ' + nextStep)

    if (nextStep === 'db') {
      window.open('/myfreebird', '_self')
    } else if (nextStep === 'mfbu') {
      window.open('/myfreebird?mu=y', '_self')
    } else {
      window.open('/myfreebird?s=' + nextStep, '_self')
    }
  }

  const handleUpgradeFromFreemium = () => {
    console.log('handleUpgradeFromFreemium...')
    const userData = {
      membershipFee: cookies.get('uD').membershipFee,
      subscriptionType: cookies.get('uD').subscriptionType,
      discount: cookies.get('uD').discount,
      discountType: cookies.get('uD').discountType,
      voucherCode: cookies.get('uD').voucherCode,
    }

    console.log('userData: ' + JSON.stringify(userData))

    props.auth.updateUser(userData).then(() => {
      cookies.set('uD', '', { path: '/' })
      cookies.set('ls', '', { path: '/' })
      cookies.set('dc', '', { path: '/' })
    })
  }

  const setPopupClosed = () => {
    setForbiddenLinkClicked(false, '')
    setNewMemberMessage('')
    //window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const handlePromoPanelClick = (e) => {
    const nextStep = 'mp'
    e.preventDefault()
    window.open('/onboarding?p=' + nextStep + '&s=db', '_self')
  }

  const handleTaskItemClick = (e, item) => {
    console.log('handleTaskItemClick...')
    console.log('item: ' + item)

    e.preventDefault()
    var nextStep = ''
    switch (item) {
      case 'email':
        nextStep = 'em'
        break
      case 'photo':
        nextStep = 'pr'
        break
      case 'profile':
        nextStep = 'pf'
        break
      case 'membership1':
        nextStep = 'mp'
        break
      case 'verify':
        nextStep = 'vf'
        break
      case 'phone':
        nextStep = 'ph'
        break
      case 'account':
        nextStep = 'ac'
        break
      case 'posthello':
        window.open(
          `/dashboard/community2?lp=freebird-club-member-introductions`,
          `_self`
        )
        break
    }
    item !== 'posthello' && window.open(`/myfreebird?s=${nextStep}`, `_self`)
  }

  const handleQueryStringStep = (item) => {
    console.log('handleQueryStringStep...')
    handleOpenPanel(item)
  }

  const handleGoBack = () => {
    if (cookies.get('fem') === 'y') {
      cookies.set('fem', '', { path: '/' })
      window.open(`/myfreebird`, `_self`)
    } else {
      window.history.go(-1)
    }
  }

  const TopPanel = () => {
    var bodyText1 = ''
    var buttonText = ''
    var buttonAction = ''

    if (props.auth.user.subscriptionType === 'freemium') {
      bodyText1 = 'Membership plan: <span>Visitor</span>'
      buttonText = 'Upgrade membership plan'
      buttonAction = 'membership1'
    } else if (
      props.auth.user.subscriptionType !== 'freemium' &&
      props.auth.user.proofIdentityStatus === 'pending'
    ) {
      bodyText1 =
        'To book Homestays, list your property for Homestays, or direct message other members you must verify your account by uploading a photo ID.'
      buttonText = 'Verify your account'
      buttonAction = 'verify'
    } else if (
      props.auth.user.subscriptionType !== 'freemium' &&
      props.auth.user.emailStatus === 'pending'
    ) {
      bodyText1 =
        'To complete your account verification you need to verify your email address.'
      buttonText = 'Verify email address'
      buttonAction = 'email'
    } else if (
      props.auth.user.subscriptionType !== 'freemium' &&
      props.auth.user.introductionStatus === 'pending'
    ) {
      bodyText1 =
        'To complete your account setup please update your profile information.'
      buttonText = 'Update profile info'
      buttonAction = 'profile'
    } else if (
      props.auth.user.subscriptionType !== 'freemium' &&
      props.auth.user.phoneStatus === 'pending'
    ) {
      bodyText1 =
        'If you wish to list a property for homestays you need to add your phone number to your account.'
      buttonText = 'Add phone number'
      buttonAction = 'phone'
    }

    if (bodyText1 !== '' && !queryParams.get('s')) {
      return (
        <FlexRowProgress>
          <TpL>
            {' '}
            <Subtitle
              color="#fff"
              size="16px"
              sizemd="16px"
              sizesm="16px"
              weight="400"
              margin="0"
              dangerouslySetInnerHTML={{
                __html: `${bodyText1}`,
              }}
            />
          </TpL>
          <TpR>
            {' '}
            <ActionButtonMyFreebird
              type="submit"
              padding="10px 60px"
              margin="0"
              fontsizesm="16px"
              onClick={(e) => handleTaskItemClick(e, buttonAction)}
            >
              {buttonText}
            </ActionButtonMyFreebird>
          </TpR>
        </FlexRowProgress>
      )
    }
  }

  const ProfileUpdatePanel = () => {
    var content = ''
    switch (profileUpdate) {
      case 'pr':
        content = <PhotoOnboarding data={props} onUpdate={panelHasUpdated} />
        break
      case 'pf':
        content = (
          <EditProfileOnboarding
            data={props}
            countriesNice={countriesNice}
            onUpdate={panelHasUpdated}
          />
        )
        break
      case 'em':
        content = (
          <EditEmailOnboarding data={props} onUpdate={panelHasUpdated} />
        )
        break
      case 'vf':
        content = (
          <ProofIdentityOnboarding data={props} onUpdate={panelHasUpdated} />
        )
        break
      case 'ph':
        content = (
          <EditPhoneNumberOnboarding data={props} onUpdate={panelHasUpdated} />
        )
        break
      case 'ac':
        content = <ManageAccount data={props} onUpdate={panelHasUpdated} />
        break
      case 'mp':
        content = (
          <ChooseSubscriptionOnboarding
            data={props}
            onComplete={handleProceed}
          />
        )
        break
      case 'mp2':
        content = (
          <ChoosePaymentOptionOnboarding
            actionRef={actionRef}
            data={props}
            onComplete={handleProceed}
          />
        )
        break
      case 'mp3':
        content = (
          <FeeSubscriptionOnboarding
            data={props}
            setIAminSubscriptionFormPanel={setIAminSubscriptionFormPanel}
            onComplete={handleProceed}
          />
        )
        break
      case 'mp4':
        content = (
          <TopSectionContainer>
            <TopSectionAction>
              {' '}
              <Title
                center
                color="#fff"
                size="34px"
                sizemd="34px"
                sizesm="30px"
                lineheight="100%"
                weight="600"
                margin="20px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `Thanks for your payment`,
                }}
              />
              <SubtitleOnboard
                color="#fff"
                size="20px"
                sizemd="20px"
                sizesm="20px"
                lineheight="100%"
                weight="200"
                margin="26px 10vw"
                dangerouslySetInnerHTML={{
                  __html: `Your payment has been processed and your membership plan has been activated. Please click on the button below to return to your dashboard.`,
                }}
              />
              <img src={'images/onboarding/icon-community.svg'} />
              <ProceedButton
                type="submit"
                padding="10px 60px"
                margin="46px 10vw 26px"
                fontsize="16px"
                onClick={(e) => {
                  handleProceed('mfbu')
                }}
              >
                Click to view dashboard
              </ProceedButton>
            </TopSectionAction>
          </TopSectionContainer>
        )
        break
    }
    return content
  }

  const MainActionPanel = () => {
    var bodyText1 = ''
    var buttonText = ''
    var buttonAction = ''

    if (props.auth.user.circleIntroStatus === 'pending') {
      bodyText1 =
        'The best way to meet Freebird members is to post a hello message into the Introductions space in the Freebird Community Hub. Click the button to post a message.'
      buttonText = 'Post a hello message'
      buttonAction = 'posthello'
    }

    if (bodyText1 !== '') {
      return (
        <FlexRowAction>
          <TpLA>
            {' '}
            <img src={'images/onboarding/icon-community.svg'} />
            <Subtitle
              color="#fff"
              size="16px"
              sizemd="16px"
              sizesm="16px"
              weight="400"
              margin="0"
              dangerouslySetInnerHTML={{
                __html: `${bodyText1}`,
              }}
            />
          </TpLA>
          <TpRA>
            {' '}
            <ActionButtonMyFreebirdGreen
              type="submit"
              padding="10px 60px"
              margin="0"
              fontsizesm="16px"
              onClick={(e) => handleTaskItemClick(e, buttonAction)}
            >
              {buttonText}
            </ActionButtonMyFreebirdGreen>
          </TpRA>
        </FlexRowAction>
      )
    }
  }

  if (
    pageText.length === 0 ||
    !currencySign ||
    !props.auth.user ||
    subscriptionType === undefined ||
    accountStatus === undefined
  ) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[22]}</span>
        </div>
      </div>
    )
  }

  if (profileUpdate) {
    return (
      <MyFreebirdSection>
        {' '}
        <ProfileUpdateSection>
          <TopSectionContainer>
            <TopPanel />
          </TopSectionContainer>
          <MainSectionContainer>
            <FlexRowOnboarding>
              <BackButton
                type="submit"
                padding="10px 60px"
                margin="0"
                fontsize="16px"
                onClick={(e) => {
                  handleGoBack()
                }}
              >
                Back
              </BackButton>
            </FlexRowOnboarding>
            <ProfileUpdatePanel />
          </MainSectionContainer>
        </ProfileUpdateSection>
      </MyFreebirdSection>
    )
  }
  return (
    <MyFreebirdSection>
      {' '}
      <TopSectionContainer>
        <TopPanel />
        <MyFreebirdProfilePanel
          pageText={pageText}
          user={user}
          country={country}
          profileEnhanced={profileEnhanced}
          onUpdate={handleTaskItemClick}
        />
        <MainActionPanel />
      </TopSectionContainer>
      <MyFreebirdNavBar user={user} promoPanelStep={promoPanelStep} />
      <MainSectionContainer>
        <MyFreebirdPopup
          pageText={pageText}
          user={user}
          forbiddenLinkClicked={forbiddenLinkClicked}
          newMemberMessage={newMemberMessage}
          onUpdate={setPopupClosed}
        />
        <MyFreebirdOpacityScreen
          user={user}
          forbiddenLinkClicked={forbiddenLinkClicked}
          newMemberMessage={newMemberMessage}
        />

        <MyFreebirdOpacityDiscountScreen
          setShowPopup={setIsPopupVisible}
          isVisible={isPopupVisible}
        />
        <MyFreebirdDiscountPopup
          pageText={pageText}
          popTitle={pageText[56]}
          popText={pageText[57]}
          user={user}
          discountCode={discountCode}
          clickedFeeLink={clickedFeeLink}
          showPopup={isPopupVisible}
          setShowPopup={setIsPopupVisible}
          setIsCopied={setIsCopied}
          iAminSubscriptionFormPanel={iAminSubscriptionFormPanel}
          setIsCopiedInSubFormPanel={setIsCopiedInSubFormPanel}
        />

        <MyFreebirdDashboard
          pageText={pageText}
          user={user}
          accountStatus={accountStatus}
          subscriptionType={subscriptionType}
          messageTrigger={setIsIntersecting}
          forbiddenLinkClicked={setForbiddenLinkClicked}
        />
      </MainSectionContainer>
    </MyFreebirdSection>
  )
}

export default withRouter(withAuth(MyFreebirdFreemium))
